module.exports = require("./hyphen.js");



//////////////////
// WEBPACK FOOTER
// ./~/hyphen/index.js
// module id = 8354
// module chunks = 2